import {Component, h} from "preact";
import {icons} from "../icons";
import styles from "./style.module.scss"
import {FilterMap, ProductFilter} from "../../models/filter";
import {filterService} from "../../services/filter-service";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {FilterType} from "../../models/product";
import {customerService} from "../../services/customer-service";
import {Like} from "../../models/customer";
import {i18nService} from "../../services/i18n-service";
import {Collection} from "../../models/collection";
import {imageService} from "../../services/image-service";
import {config} from "../../config";

interface Props {
    toggleFilter(filter: ProductFilter);

    toggleIsFilterModalDisplayed(show?: boolean);

    openInterstitial();

    filters: FilterMap;
    likes: Like[];

    filter: ProductFilter;
    collections: Collection[];
    isCustomFilter: boolean;
    isBubbleFilter: boolean;
}

const mapToProps = ({filters, likes, collections}) => ({filters, likes, collections});

class Filter extends Component<Props, any> {

    private _toggleFilter(filter: ProductFilter) {
        this.props.toggleFilter(filter);
        this.props.toggleIsFilterModalDisplayed(false);
    }

    private getParamsKey(filterType: FilterType) {
        switch (filterType) {
            case FilterType.Custom:
                return "custom"
            case FilterType.Collection:
                return "collection"
            case FilterType.Editorial:
                return "editorials"
            case FilterType.Like:
                return "likes"
            case FilterType.Brand:
                return "brand"
            case FilterType.Color:
                return "color"
            case FilterType.Category:
                return "web_category"
            default:
                return ""
        }
    }

    private getSearchParams(filter: ProductFilter) {
        const search = new URLSearchParams(window.location.search);
        const newSearch = new URLSearchParams([["gender", search.get("gender")]]);

        const key = this.getParamsKey(filter.type);

        if (filter.type == FilterType.Custom) {
            if (filter.name != search.get(key)) {
                newSearch.set(key, filter.name);
            }

            return `/?${newSearch.toString()}`;
        } else if (filter.type == FilterType.Like) {
            if (!filter.selected) {
                newSearch.set(key, "like");
            }

            return `/?${newSearch.toString()}`;
        } else if (filter.type == FilterType.Editorial) {
            if (filter.value == search.get(key)) {
                newSearch.delete(key);
            } else {
                newSearch.set(key, filter.value);
            }

            return `/?${newSearch.toString()}`;
        } else if(filter.type == FilterType.Color) {
            if(search.has(key)) {
                let colors = search.get(key).split(",");

                if(colors.includes(filter.value.id)) {
                    colors = colors.filter(c => c != filter.value.id);
                } else {
                    colors.push(filter.value.id);
                }

                if(colors.length > 0) {
                    search.set(key, colors.join(","));
                } else {
                    search.delete(key);
                }
            } else {
                search.set(key, filter.value.id);
            }
        } else {
            if (filter.value == search.get(key)) {
                search.delete(key);
            } else {
                search.set(key, filter.value);
            }
        }

        return `/?${search.toString()}`;
    }

    render() {
        const filter = this.props.filter;

        if (filter.type === FilterType.Like) {
            return (
                <div class={`${styles['like-filter']} ${filter.selected ? styles.selected : ''}`}>
                    {customerService.isLoggedIn ? (
                        <a
                            href={config.url(this.getSearchParams(filter))}
                            onClick={() => this._toggleFilter(filter)}
                            title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                        >
                            <span className={`${styles.heart} ${customerService.isLoggedIn && this.props.likes ? styles.fill : ''}`}>{icons.renderHeartIcon()}</span>
                            {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                            <span className={styles['likes-count']}>{customerService.isLoggedIn && `(${this.props.likes.filter(like => like.product).length})`}</span>
                            {filter.selected &&
                                <span className={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                            }
                        </a>
                    ) : (
                        <span
                            onClick={() => this.handleLikeFilterToggle(filter)}
                            title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                        >
                            <span className={`${styles.heart} ${customerService.isLoggedIn && this.props.likes ? styles.fill : ''}`}>{icons.renderHeartIcon()}</span>
                            {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                            <span className={styles['likes-count']}>{customerService.isLoggedIn && `(${this.props.likes.filter(like => like.product).length})`}</span>
                            {filter.selected &&
                                <span className={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                            }
                        </span>
                    )}
                </div>
            )
        } else if (filter.type === FilterType.Editorial) {
            if (this.props.isBubbleFilter) {
                return (
                    <div class={`${styles['bubble-filter']} ${this.props.filters.editorials.length <= 4 ? styles['few'] : ''}`} onClick={() => this._toggleFilter(filter)}>
                        <img src={imageService.getImagePreviewUrl(filter.image_key)}/>
                        <div class={styles['bubble-editorial-name']}>{filter.name}</div>
                    </div>
                )
            }

            return (
                <div class={`${styles['default-filter']} ${filter.selected ? styles.selected : ''}`}>
                    <a
                        href={config.url(this.getSearchParams(filter))}
                        onClick={() => this._toggleFilter(filter)}
                        title={filter.name}
                    >
                        {filter.name}
                        {filter.selected &&
                            <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                        }
                    </a>
                </div>
            )
        } else return (
            <div class={`${this.props.isCustomFilter ? styles['custom-filter'] : styles['default-filter']} ${this.props.isCustomFilter && filter.name === 'sale' ? styles['sale-filter'] : ''} ${filter.selected ? styles.selected : ''}`}>
                <a
                    href={config.url(this.getSearchParams(filter))}
                    onClick={() => this._toggleFilter(filter)}
                    title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                >
                    {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                    {filter.selected &&
                        <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                    }
                </a>
                {filter.expanded &&
                    <div class={`${styles['sub-filter']}`}>
                        {filter.filters.map((subFilter: ProductFilter) => {
                            return (
                                <div class={`${styles['default-filter']} ${!filter.selected && subFilter.selected ? styles.selected : ''}`}>
                                    <a
                                        href={config.url(this.getSearchParams(subFilter))}
                                        onClick={() => this._toggleFilter(filter)}
                                        title={i18nService.translate(filterService.getTranslationKey(subFilter, this.props.filters.gender))}
                                    >
                                        {i18nService.translate(filterService.getTranslationKey(subFilter, this.props.filters.gender))}
                                        {!filter.selected && subFilter.selected &&
                                            <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                                        }
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }

    handleLikeFilterToggle(filter: ProductFilter) {
        if (customerService.isLoggedIn) {
            this.props.toggleFilter(filter)
        } else {
            this.props.openInterstitial();
        }
        this.props.toggleIsFilterModalDisplayed(false);
    }
}

export default connect(mapToProps, actions)(Filter)
